function isSkillDetailPage(): boolean {
  const urlPattern = /ixl\.com\/(math|ela|science)\/([\w-]+)\/([\w-]+)/i;
  const currentUrl = window.location.href;

  // Check if the current URL matches the pattern
  const match = currentUrl.match(urlPattern);
  return !!match;
}

function isEligiblePage(): boolean {
  const url = window.location.href;
  const domains = ['readtheory.org', 'khanacademy.org'];

  return domains.some(domain => url.includes(domain));
}

function isQuizPage(): boolean {
  const urlPattern = /ixl\.com\/quizzes/i;
  const currentUrl = window.location.href;
  return !!currentUrl.match(urlPattern);
}

function isDiagnosticArena(): boolean {
  const urlPattern = /ixl\.com\/diagnostic\/arena(\S*)/i;
  const currentUrl = window.location.href;
  return !!currentUrl.match(urlPattern);
}

export function isEligibleForPopUp(): boolean {
  return isSkillDetailPage() || isDiagnosticArena() || isQuizPage() || isEligiblePage();
}
